export default __webpack_public_path__ + "static/media/flightDetails1.843b0ad5.PNG";